import { TermsAndConditions } from '@thehubz/shared/model';

export const termsAndConditions: TermsAndConditions = {
  assetDownload: `
    <p>Alle Angaben ohne Gewähr.</p>
    <p>
      Da die Werbemittel-Produktion erstmals im Rahmen des bestehenden Agenturvertrag durch die Serviceplan Make GmbH & Co. KG abgewickelt wird, möchten wir an dieser Stelle der Sorgfaltspflicht
      halber darauf hinweisen, dass die Haftung für die Daten für die Werbemittelerstellung, die aus der Schnittstelle gezogen werden, auf Seiten des Auftraggebers liegt.
    </p>
    <p>
      Zudem stimmen Sie mit dem Download der Werbemittel zu, für die Überprüfung der Richtigkeit der Werbemittel bezüglich der kommunizierten Jackpot-Werte und des nächsten Ziehungsdatums bzw.
      Ziehungstags zu sorgen und dass die Werbemittel nur während der Gültigkeit der Jackpot-Werte bzw. vor dem Ziehungstag/datum veröffentlicht werden. Die aktuellen Jackpot-Werte und das
      Datum/den Tag der nächsten Ziehung finden Sie unter <a href="https://www.eurojackpot.de" target="_blank" rel="noopener">https://www.eurojackpot.de</a>.
    </p>
    <p>
      Die Serviceplan Make GmbH & Co. KG, als Bereitsteller dieser Website, übernimmt keine Haftung für den korrekten Einsatz der zur Verfügung gestellten Werbemittel durch den Nutzer. Die
      Richtigkeit der zur Verfügung gestellten Daten auf <a href="https://www.eurojackpot.de" target="_blank" rel="noopener">https://www.eurojackpot.de</a> und aus der Schnittstelle, unterliegt
      zudem dem Auftraggeber.
    </p>
    `,
};
